module.exports = __webpack_public_path__ + "img/taiwanHighSpeedRail-7-11.86205afb.jpg";